/* tslint:disable */
/* eslint-disable */
/**
 * GLC.ClientPortal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { IntermediaryDetail } from './IntermediaryDetail';
import {
    IntermediaryDetailFromJSON,
    IntermediaryDetailFromJSONTyped,
    IntermediaryDetailToJSON,
} from './IntermediaryDetail';

/**
 * 
 * @export
 * @interface InvestmentIntermediaryDetails
 */
export interface InvestmentIntermediaryDetails {
    /**
     * 
     * @type {number}
     * @memberof InvestmentIntermediaryDetails
     */
    investmentId: number;
    /**
     * 
     * @type {string}
     * @memberof InvestmentIntermediaryDetails
     */
    investmentNumber: string;
    /**
     * 
     * @type {string}
     * @memberof InvestmentIntermediaryDetails
     */
    investmentName: string;
    /**
     * 
     * @type {Array<IntermediaryDetail>}
     * @memberof InvestmentIntermediaryDetails
     */
    intermediaries: Array<IntermediaryDetail>;
    /**
     * 
     * @type {boolean}
     * @memberof InvestmentIntermediaryDetails
     */
    hasInitialFee: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof InvestmentIntermediaryDetails
     */
    hasRecurringFee: boolean;
    /**
     * 
     * @type {number}
     * @memberof InvestmentIntermediaryDetails
     */
    totalInitialFee?: number;
    /**
     * 
     * @type {number}
     * @memberof InvestmentIntermediaryDetails
     */
    totalRecurringFee?: number;
    /**
     * 
     * @type {number}
     * @memberof InvestmentIntermediaryDetails
     */
    totalAnnualFee?: number;
}

/**
 * Check if a given object implements the InvestmentIntermediaryDetails interface.
 */
export function instanceOfInvestmentIntermediaryDetails(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "investmentId" in value;
    isInstance = isInstance && "investmentNumber" in value;
    isInstance = isInstance && "investmentName" in value;
    isInstance = isInstance && "intermediaries" in value;
    isInstance = isInstance && "hasInitialFee" in value;
    isInstance = isInstance && "hasRecurringFee" in value;

    return isInstance;
}

export function InvestmentIntermediaryDetailsFromJSON(json: any): InvestmentIntermediaryDetails {
    return InvestmentIntermediaryDetailsFromJSONTyped(json, false);
}

export function InvestmentIntermediaryDetailsFromJSONTyped(json: any, ignoreDiscriminator: boolean): InvestmentIntermediaryDetails {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'investmentId': json['InvestmentId'],
        'investmentNumber': json['InvestmentNumber'],
        'investmentName': json['InvestmentName'],
        'intermediaries': ((json['Intermediaries'] as Array<any>).map(IntermediaryDetailFromJSON)),
        'hasInitialFee': json['HasInitialFee'],
        'hasRecurringFee': json['HasRecurringFee'],
        'totalInitialFee': !exists(json, 'TotalInitialFee') ? undefined : json['TotalInitialFee'],
        'totalRecurringFee': !exists(json, 'TotalRecurringFee') ? undefined : json['TotalRecurringFee'],
        'totalAnnualFee': !exists(json, 'TotalAnnualFee') ? undefined : json['TotalAnnualFee'],
    };
}

export function InvestmentIntermediaryDetailsToJSON(value?: InvestmentIntermediaryDetails | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'InvestmentId': value.investmentId,
        'InvestmentNumber': value.investmentNumber,
        'InvestmentName': value.investmentName,
        'Intermediaries': ((value.intermediaries as Array<any>).map(IntermediaryDetailToJSON)),
        'HasInitialFee': value.hasInitialFee,
        'HasRecurringFee': value.hasRecurringFee,
        'TotalInitialFee': value.totalInitialFee,
        'TotalRecurringFee': value.totalRecurringFee,
        'TotalAnnualFee': value.totalAnnualFee,
    };
}

